export default function SystemBrand() {
  return (
    <span className="d-flex gap-3 align-items-center">
      <span className="display-3 fw-bold">Indberetningsportal</span>
    </span>
  );
}
